import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'field-msg-error',
  templateUrl: './field-msg-error.component.html',
  styleUrls: ['./field-msg-error.component.css']
})
export class FieldMsgErrorComponent implements OnInit {

  @Input() mostraErro: any;
  @Input() submitted: boolean = false;
  // @Input() msgErro: string = '*O campo é Obrigatório';
  
  constructor() { }
  
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/field-msg-error/field-msg-error.component.ts